export default "__VITE_ASSET__BLRH$phk__"